import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, DollarSign, Clock, CheckCircle, XCircle, Eye } from 'lucide-react';
import config from '../config';

export const InstallerBidsPage = () => {
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBids();
  }, []);

  const fetchBids = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await fetch(config.getApiUrl('/marketplace/bids/'), {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setBids(data.results || data);
      }
    } catch (error) {
      console.error('Error fetching bids:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      pending: 'bg-yellow-100 text-yellow-800',
      accepted: 'bg-green-100 text-green-800',
      rejected: 'bg-red-100 text-red-800',
    };
    const statusText = {
      pending: 'در انتظار پاسخ',
      accepted: 'پذیرفته شده',
      rejected: 'رد شده',
    };
    return (
      <span className={`px-2 py-1 text-xs rounded-full ${statusMap[status] || 'bg-gray-100'}`}>
        {statusText[status] || status}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="p-6 border-b border-gray-200">
            <h1 className="text-2xl font-bold text-gray-900">پیشنهادات من</h1>
          </div>

          {bids.length === 0 ? (
            <div className="p-12 text-center text-gray-500">
              <DollarSign className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <p>شما هنوز پیشنهادی ارسال نکرده‌اید</p>
              <Link to="/marketplace" className="mt-4 inline-block bg-blue-600 text-white px-6 py-2 rounded-lg">
                مشاهده درخواست‌های جدید
              </Link>
            </div>
          ) : (
            <div className="divide-y divide-gray-200">
              {bids.map((bid) => (
                <div key={bid.id} className="p-6">
                  <div className="flex flex-wrap justify-between items-start">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <span className="font-bold text-gray-900">#{bid.id}</span>
                        {getStatusBadge(bid.status)}
                      </div>
                      <div className="text-2xl font-bold text-blue-600">
                        {bid.proposed_cost?.toLocaleString()} تومان
                      </div>
                      <div className="text-sm text-gray-500 mt-2">
                        {bid.installation_request?.address?.substring(0, 100)}...
                      </div>
                      <div className="text-xs text-gray-400 mt-1">
                        ارسال شده: {new Date(bid.created_at).toLocaleDateString('fa-IR')}
                      </div>
                    </div>
                    <Link
                      to={`/installations/${bid.installation_request}`}
                      className="flex items-center gap-1 text-blue-600 hover:text-blue-800"
                    >
                      <Eye className="w-4 h-4" />
                      مشاهده درخواست
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
